import { useContext } from 'react';

import { ShareUpToMessageContext } from './ShareUpToMessageContext';
import type { ShareUpToMessageContextValue } from './shareUpToMessageTypes';

/**
 * Returns the share-up-to-message callback, or `undefined` when no provider
 * is mounted. Per-message share buttons use the `undefined` result to hide
 * themselves in embeddings that do not support the share-snapshot flow.
 */
export const useShareUpToMessage = (): ShareUpToMessageContextValue | undefined =>
	useContext(ShareUpToMessageContext);
